var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-preloader"}},[_c('div',{staticClass:"loader-main"},[_c('div',{staticClass:"preload-spinner border-highlight"})])])
}]

export { render, staticRenderFns }